import { FormItemTypes } from '@bimser/core';
import LayoutControl from '../../base/LayoutControl';
import IColumnProperties from './entities/IColumnProperties';

export default class Column extends LayoutControl {
	constructor() {
		super();
		this.controlType = FormItemTypes.EContainerTypes.Column;
	}

	__onPropertyReceived(data: IColumnProperties) {
		super.__loadProperties(data);
	}

	render(children?: React.ReactNode) {
		return super.__render(children);
	}
}
